import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddressSelectorDto, AmbitSelectorDto } from '../shared.address.ambit.selector.component';

@Component({
  selector: 'shared-address-ambit-selector-popup-component',
  templateUrl: './shared.address.ambit.selector.popup.component.html',
  styleUrls: ['./shared.address.ambit.selector.popup.component.scss']
})
export class SharedAddressAmbitSelectorPopupComponent {
  public searchText: string = '';
  public filteredItems: (AddressSelectorDto | AmbitSelectorDto)[];

  constructor(
    public dialogRef: MatDialogRef<SharedAddressAmbitSelectorPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      items: Array<AddressSelectorDto | AmbitSelectorDto>,
      type: string,
      title: string,
      searchText: string
    }
  ) {
    this.searchText = this.data.searchText || '';
    this.filteredItems = this.data.items;
  }


  public selectItem(item: AddressSelectorDto | AmbitSelectorDto): void {
    this.dialogRef.close(item);
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public pretty(value: any): string {
    return JSON.stringify(value);
  }

}
